/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FlexColumn, FlexRow } from '../GridsAndLayouts';
import Typography from '../Typography';
import './FeedAvatarFeed.scss';

const FeedAvatarItem = ({ avatar, title, meta, description, className = '', ...rest }) => (
  <FlexRow className={classNames('ds-feed-avatar-item', className)} role="article" align="start" gap={10} {...rest}>
    <FlexRow className="ds-feed-avatar-item__avatar" inline fullWidth={false} align="center" justify="center">
      {avatar}
    </FlexRow>
    <FlexColumn className="ds-feed-avatar-item__body" align="start" gap={3}>
      <FlexRow className="ds-feed-avatar-item__top" justify="between" align="center" fullWidth gap={8}>
        <Typography component="div" variant="bodyMedium" fontWeight="medium" className="ds-feed-avatar-item__title">
          {title}
        </Typography>
        {meta != null && meta !== '' ? (
          <Typography component="div" variant="bodyExtraSmall" className="ds-feed-avatar-item__meta">
            {meta}
          </Typography>
        ) : null}
      </FlexRow>
      {description != null && description !== '' ? (
        <Typography component="div" variant="bodyExtraSmall" className="ds-feed-avatar-item__description">
          {description}
        </Typography>
      ) : null}
    </FlexColumn>
  </FlexRow>
);

FeedAvatarItem.propTypes = {
  avatar: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  meta: PropTypes.node,
  description: PropTypes.node,
  className: PropTypes.string,
};

const FeedAvatarFeed = ({ items, className = '', ...rest }) => (
  <FlexColumn className={classNames('ds-feed-avatar-feed', className)} align="stretch" fullWidth {...rest}>
    {items.map((item, i) => (
      <FeedAvatarItem key={item.key ?? i} {...item} />
    ))}
  </FlexColumn>
);

const itemShape = PropTypes.shape({
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  avatar: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  meta: PropTypes.node,
  description: PropTypes.node,
});

FeedAvatarFeed.propTypes = {
  items: PropTypes.arrayOf(itemShape).isRequired,
  className: PropTypes.string,
};

export { FeedAvatarFeed, FeedAvatarItem };
export default FeedAvatarFeed;
